/* Cut Catering — service worker registration
 *
 * Registra /service-worker.js. Su update di una versione già installata
 * ricarichiamo silenziosamente la pagina (controllerchange + reload).
 *
 * IMPORTANTE: NON ricarichiamo al primo install (quando navigator.
 * serviceWorker.controller era null al register time). In quel caso
 * `clients.claim()` triggera comunque `controllerchange` ma è il primo
 * SW che prende controllo di una pagina che funziona già: un reload qui
 * interromperebbe operazioni in corso (es. /qr-login in mezzo al consume
 * del token, causando un 401 al ritentativo perché il QR è monouso).
 */

const SW_URL = '/service-worker.js';
const UPDATE_INTERVAL_MS = 60 * 60 * 1000; // 1h

let refreshing = false;

export function register() {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;

  // Snapshot prima del register: se !hadController siamo al primo install,
  // niente reload sul controllerchange iniziale.
  const hadController = !!navigator.serviceWorker.controller;

  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register(SW_URL);

      setInterval(() => {
        registration.update().catch(() => {});
      }, UPDATE_INTERVAL_MS);

      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (refreshing) return;
        if (!hadController) return; // primo install — non ricaricare
        refreshing = true;
        window.location.reload();
      });
    } catch (err) {
      console.warn('SW registration failed:', err);
    }
  });
}

export async function getRegistration() {
  if (typeof window === 'undefined') return null;
  if (!('serviceWorker' in navigator)) return null;
  return navigator.serviceWorker.ready;
}

export async function unregister() {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;
  try {
    const reg = await navigator.serviceWorker.ready;
    await reg.unregister();
  } catch (err) {
    console.warn('SW unregister failed:', err);
  }
}
